import BaseApi from './base'

// Uploading a kit configuration file is a multi-MB multipart request; the shared axios
// instance's default timeout (`REACT_APP_AXIOS_REQUEST_TIMEOUT || 3000`, i.e. 3 seconds) is
// too short for it. Override PER CALL, here only — never raise the global default.
const UPLOAD_REQUEST_TIMEOUT = 60000

class KitConfigurationVersionPers extends BaseApi {
  getListKitConfigurationVersionPers = (query) =>
    this.client.get(`pers-kit-configuration-versions?${query}`)

  getDetailKitConfigurationVersionPers = (id) =>
    this.client.get(`pers-kit-configuration-versions/${id}`)

  getStoredFileFooters = (id) =>
    this.client.get(`pers-kit-configuration-versions/${id}/stored-file-footers`)

  addKitConfigurationVersionPers = (data) =>
    this.client.post('pers-kit-configuration-versions', data, {
      timeout: UPLOAD_REQUEST_TIMEOUT
    })

  updateKitConfigurationVersionPers = ({
    kitConfigurationVersionId,
    payload
  }) =>
    this.client.patch(
      `pers-kit-configuration-versions/${kitConfigurationVersionId}`,
      payload,
      { timeout: UPLOAD_REQUEST_TIMEOUT }
    )

  deleteKitConfigurationVersionPers = (id) =>
    this.client.delete(`pers-kit-configuration-versions/${id}`)
}

export default new KitConfigurationVersionPers()
